module.exports = __webpack_public_path__ + "26498c0dde9289f73e5950780e6c180b.svg";